/* Judge.me injects interface labels after the theme has rendered. Translate labels only;
   preserve customer names, review titles, review bodies and product print artwork. */
(() => {
  'use strict';
  if (!document.documentElement.lang.toLowerCase().startsWith('hu')) return;
  const map = window.FG_HU_TEXT || {};
  const excluded = 'script,style,textarea,[contenteditable],.jdgm-rev__body,.jdgm-rev__title,.jdgm-rev__author,.jdgm-review-content,.jdgm-reviewer-name,[data-review-body]';
  const roots = '.jdgm-widget,.jdgm-review-widget,.jdgm-form,.jdgm-popup,.shopify-policy__title';
  function translate(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest(excluded)) continue;
      const source = node.nodeValue.trim();
      if (map[source] && map[source] !== source) node.nodeValue = node.nodeValue.replace(source, map[source]);
      else if (/^Based on (\d+) reviews?$/.test(source)) node.nodeValue = source.replace(/^Based on (\d+) reviews?$/, '$1 értékelés alapján');
      else if (/^(\d+) reviews?$/.test(source)) node.nodeValue = source.replace(/^(\d+) reviews?$/, '$1 értékelés');
    }
    root.querySelectorAll('[placeholder],[aria-label]').forEach(el => {
      for (const attr of ['placeholder','aria-label']) { const value = el.getAttribute(attr); if (map[value] && map[value] !== value) el.setAttribute(attr, map[value]); }
    });
    root.querySelectorAll('input[type="submit"],input[type="button"]').forEach(el => { if (map[el.value]) el.value = map[el.value]; });
  }
  function start() {
    let queued = false;
    const run = () => { queued = false; document.querySelectorAll(roots).forEach(translate); };
    run();
    new MutationObserver(records => {
      if (queued || !records.some(r => r.type === 'characterData' || r.addedNodes.length)) return;
      queued = true; requestAnimationFrame(run);
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
